<div [class]="currentLanguage" style="height: 100%" *ngIf="!isBrowserUnsupported">
    <app-message></app-message>
    <price-sidebar></price-sidebar>
    <selfcare-timeout></selfcare-timeout>
    <maintenance-info [maintenanceType]="1"></maintenance-info>
    <router-outlet></router-outlet>
    <consolelogger></consolelogger>
</div>
